import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {CheckoutError} from "../../checkout/Checkout";
import {useCheckoutContext} from "../../checkout/CheckoutContextProvider/CheckoutContextProvider";
import {useCheckoutViewContext} from "../../checkout/CheckoutContextProvider/CheckoutViewContextProvider";
import {Button, ButtonStyles} from "../form/Button/Button";
import window from "../WindowExtended";
import {amazonPayWalletContainerId, cancelAmazonPay, widgetOptions} from "./AmazonPayLibrary";

const AmazonPayWalletWidget: React.FC<{
  errors: string[];
  onError: (errorString: string) => void;
}> = (props) => {
  const {checkout} = useCheckoutContext();
  const {gotoStep} = useCheckoutViewContext();
  const {t} = useTranslation("checkout");

  useEffect(() => {
    if (!window.amazon) {
      return;
    }

    new window.OffAmazonPayments.Widgets.Wallet({
      amazonOrderReferenceId: window.orderReferenceId,
      onError: (err) => props.onError(`${err.getErrorCode()}: ${err.getErrorMessage()}`),
      onPaymentSelect: () => {
        window.isBillingAgreementPaymentSet = true;
      },
      ...widgetOptions,
    })
      .setPresentmentCurrency(window.c_ActiveCurrency)
      .bind(amazonPayWalletContainerId);
  }, []);

  const continueCheckout = () => {
    gotoStep();
  };

  const cancel = () => {
    cancelAmazonPay();
    void checkout.put({paymentId: 0}).then(null);
  };

  return (
    <div className="reduced-width">
      <CheckoutError>{props.errors}</CheckoutError>
      <div style={{marginBottom: "1rem"}}>
        <div id={amazonPayWalletContainerId} style={{height: "230px", marginBottom: ".5rem"}}>
          {/* Filled by Amazon Pay */}
        </div>
        <span style={{cursor: "pointer", color: "#1ba1e2"}} onClick={cancel}>
          {t("Zahlung mit Amazon Pay abbrechen")}
        </span>
      </div>
      <Button styles={[ButtonStyles.wide]} action={continueCheckout}>
        {t("Weiter")}
      </Button>
    </div>
  );
};

export default AmazonPayWalletWidget;
